// extracted by mini-css-extract-plugin
export default {"hideTooltip":"v--z","fadeIn":"w--z","delay":"x--z","recommendedSizeTooltip":"y--z"};